import { render, staticRenderFns } from "./ProjectWorker.vue?vue&type=template&id=cef4472c&scoped=true"
import script from "./ProjectWorker.vue?vue&type=script&lang=js"
export * from "./ProjectWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef4472c",
  null
  
)

export default component.exports